<template>
  <div class="px-3">

    <div class="text-h5green--text" v-if="afterReg === true">Регистрация завершена!</div>

    Чтобы воспользоваться нашим сервисом вы можете установить приложения для Android или iOS:



  

      <div :class="['pt-3', { 'd-flex': !isMobile }]">
        <a class="d-block mr-3" href="https://play.google.com/store/apps/details?id=com.gorodok.mobile">
        <img 
            src="@/assets/logo_google_play.png" /></a>
        <a class="d-block" href="https://itunes.apple.com/ru/app/sistema-gorod-altajskij-kraj/id1077226959"><img
            src="@/assets/logo_apple_store.png" /></a>
      </div>

    или перейти на наш <a href="https://lk.sistemagorod.ru/lk/">веб-сайт</a>

    <template v-if="!isMobile">
      <div  class="d-flex justify-center mt-3">
      <img src="@/assets/sgqr.svg" />
      </div>
      <div class="grey--text text-body-2 text-center">Наведите на камеру для скачивания мобильного приложения</div>

    </template>



  </div>
</template>

<script>
  export default {
    props: {
      afterReg: {
        type: Boolean,
        required: false
      }
    }
  }
</script>

<style>

</style>